import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    step: 1,
    loading: false,
    categories: [],
    courseInformation: null,
    course: [],
    paymentLoading: false,
}

const courseSlice = createSlice({
    name: 'course',
    initialState,
    reducers: {
        setStep: (state, action) => {
            state.step = action.payload;
        },
        setCourseInformation: (state, action) => {
            state.courseInformation = action.payload;
        },
        setCourse: (state, action) => {
            state.course = action.payload;
        },
        updateSectionName: (state, action) => {
            const { sectionName, newSectionName, sectionIndex } = action.payload;
            const updatedCourse = [...state.course];
            updatedCourse[sectionIndex] = {
                [newSectionName]: updatedCourse[sectionIndex][sectionName],
            };
            if (sectionName !== newSectionName) {
                delete updatedCourse[sectionIndex][sectionName];
            }
            state.course = updatedCourse;
        },
        deleteSection: (state, action) => {
            const { sectionIndex } = action.payload;
            const updatedCourse = state.course.filter((_, index) => index !== sectionIndex);
            state.course = updatedCourse;
        },
        subSectionInSection: (state, action) => {
            const { title, description, file, fileType, sectionIndex, sectionName, duration } = action.payload;
            const updatedCourse = [...state.course];
            const newLecture = { title, description, file, fileType, duration };
            updatedCourse[sectionIndex][sectionName].push(newLecture);
            state.course = updatedCourse;
        },
        updateSubSection: (state, action) => {
            const { title, description, file, fileType, sectionIndex, sectionName, duration, subSectionIndex } = action.payload;
            const updatedCourse = [...state.course];
            const updatedLecture = { title, description, file, fileType, duration };
            updatedCourse[sectionIndex][sectionName][subSectionIndex] = updatedLecture;
            state.course = updatedCourse;
        },
        deleteSubSection: (state, action) => {
            const { subSectionIndex, sectionIndex, sectionName } = action.payload;
            const updatedCourse = [...state.course];
            updatedCourse[sectionIndex][sectionName] = updatedCourse[sectionIndex][sectionName].filter(
                (_, index) => index !== subSectionIndex
            );
            state.course = updatedCourse;
        },
        setPaymentLoading: (state, action) => {
            state.paymentLoading = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setCategories: (state, action) => {
            state.categories = action.payload;
        },
        resetCourseState: (state) => {
            state.step = 1;
            state.courseInformation = null;
            state.course = [];
            state.loading = false;
            state.paymentLoading = false;
        },
    },
})

export const {
    setStep,
    setLoading,
    updateSectionName,
    setCourseInformation,
    setCourse,
    setCategories,
    setPaymentLoading,
    resetCourseState,
    deleteSection,
    subSectionInSection,
    updateSubSection,
    deleteSubSection,
} = courseSlice.actions;

export default courseSlice.reducer; 